export default "__VITE_ASSET__DAm3bVSZ__"